import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CalendarIcon } from 'lucide-react';
export function TemporaryDumpsters() {
  return <div className="w-full min-h-screen bg-white" data-id="element-325">
      <Header data-id="element-326" />
      {/* Hero Section */}
      <section className="relative h-[400px] w-full" data-id="element-327">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3GWcmUk43FziaU7hby49mH/TemporaryDumpsters.png" alt="Temporary Dumpsters" className="w-full h-full object-cover" data-id="element-328" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" data-id="element-329"></div>
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-330">
          <div className="text-center" data-id="element-331">
            <div className="w-20 h-20 bg-white rounded-lg flex items-center justify-center mx-auto mb-4" data-id="element-332">
              <CalendarIcon className="w-10 h-10 text-[#E41C1C]" data-id="element-333" />
            </div>
            <h1 className="text-5xl font-bold text-white" data-id="element-334">
              Temporary Dumpsters
            </h1>
          </div>
        </div>
      </section>
      {/* Content Section */}
      <section className="py-16 bg-white" data-id="element-335">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-336">
          <div className="space-y-6" data-id="element-337">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-338">
              Life brings unexpected projects—moving, remodeling, hosting a
              large event, or cleaning out years of accumulated belongings. Our
              temporary dumpster service provides short-term rentals in 2, 4, 6,
              and 8-yard sizes, giving you the flexibility to tackle these
              projects efficiently without committing to long-term service. We
              deliver the dumpster to your location, let you fill it at your own
              pace, and pick it up when you're ready.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-339">
              This service is perfect for homeowners managing one-time projects,
              businesses hosting special events, or anyone who needs temporary
              waste management for a specific purpose. The rental period is
              flexible, and we work with you to ensure the dumpster is available
              for as long as you need it. Whether it's a weekend clean-up or a
              month-long renovation, we've got you covered.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-340">
              Our temporary dumpsters are well-maintained, appropriately sized
              for residential driveways and job sites, and delivered with care
              to avoid damage to your property. With straightforward pricing and
              no surprise fees, you can focus on your project knowing that waste
              removal is one less thing to worry about. Sam's Disposal makes
              temporary dumpster rental simple, affordable, and reliable.
            </p>
          </div>
          {/* CTA Section */}
          <div className="mt-12 p-8 bg-gray-50 rounded-lg text-center" data-id="element-341">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-342">
              Rent a Temporary Dumpster
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-343">
              Get the right size dumpster for your project delivered when you
              need it.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-344">
              <a href="tel:231-796-2952" className="bg-[#E41C1C] text-white font-bold px-8 py-4 rounded hover:bg-red-700 transition-colors text-lg" data-id="element-345">
                Call (231) 796-2952
              </a>
              <button className="bg-white border-2 border-[#E41C1C] text-[#E41C1C] font-bold px-8 py-4 rounded hover:bg-gray-50 transition-colors text-lg" data-id="element-346">
                Request Rental
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-347" />
    </div>;
}